const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CookieManagementCommand: any = {
    CreateCookie: Backofficebff + '/v1/cookiemanagement/create-cookie',
    UpdateCookie: Backofficebff + '/v1/cookiemanagement/update-cookie',
    DeleteCookie: Backofficebff + '/v1/cookiemanagement/delete-cookie',
    CreateCookieType: Backofficebff + '/v1/cookiemanagement/create-cookie-type',
    UpdateCookieType: Backofficebff + '/v1/cookiemanagement/update-cookie-type',
};
